export default __webpack_public_path__ + "static/media/benelli-m4.7218f47b.svg";